var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('span',{staticClass:"tit"},[_vm._v(_vm._s(_vm.tit)+":")]),_vm._v(" "),_c('Echart',{attrs:{"id":_vm.id,"options":_vm.options,"height":"60px","width":"550px"}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("个")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e72ce44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/screen/components/leftTopChart/index.vue
// module id = null
// module chunks = 